/* External */
import {
  memo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Components */
import FocusableButton from '../../../../components/FocusableButton/FocusableButton';

/* Services */
import { gaService } from '../../../../services/gaService';

/* Utils */
import { Direction } from '../../../../utils/spatialNavigation';
import { noOp } from '../../../../utils/functions';
import { REPORT_GA } from '../../../../utils/constants';
import { SETTINGS } from '../../../../utils/focusKey';

function handleArrowPressNoOp(noOpDirections) {
  return (direction) => noOpDirections.every(
    (noOpDirection) => direction !== noOpDirection,
  );
}

function SignOffCta({ onArrowPress, onEnterPress }) {
  const noOpDirections = [Direction.UP, Direction.DOWN];

  const handleNoOpDirections = handleArrowPressNoOp(noOpDirections);
  const handleArrowPress = (direction) => (
    handleNoOpDirections(direction) && onArrowPress(direction)()
  );

  const handleEnterPress = useCallback(() => {
    onEnterPress();
    gaService.sendEvent({
      action: REPORT_GA.GA_EVENT_ACTION_INTENTION,
      label: REPORT_GA.GA_EVENT_LABEL_NA,
      category: REPORT_GA.GA_EVENT_CATEGORY_LOGOUT,
    });
  }, [onEnterPress]);

  return (
    <FocusableButton
      primary
      focusKey={SETTINGS.EXIT}
      onEnterPress={handleEnterPress}
      onArrowPress={handleArrowPress}
    >
      <FormattedMessage id="common.logout" />
    </FocusableButton>
  );
}

SignOffCta.defaultProps = {
  onArrowPress: noOp,
  onEnterPress: noOp,
};

SignOffCta.propTypes = {
  onArrowPress: PropTypes.func,
  onEnterPress: PropTypes.func,
};

export default memo(SignOffCta);
